import gql from 'graphql-tag';

import MenuImageFragment from './menu-image';

export default gql`
  fragment MenuImagesFragment on Images {
    app {
      ...MenuImageFragment
    }
    kiosk {
      ...MenuImageFragment
    }
    imageDescription
  }
  ${MenuImageFragment}
`;
